import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
import React from "react";

const ReportsInspectionsSubmissionSummaryList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsInspectionsSubmissionSummary/ReportsInspectionsSubmissionSummaryList/ReportsInspectionsSubmissionSummaryList"
    )
);
export const ReportsInspectionsSubmissionSummary = () => {
  return (
    <Layout>
      <ReportsInspectionsSubmissionSummaryList />
    </Layout>
  );
};
